module.exports = __webpack_public_path__ + "img/album21_34.31d8e31f.jpg";